export const notNullUndefined = <TValue> (value: TValue | null | undefined): value is TValue => {
    return value !== null && value !== undefined;
}

export const isNullUndefined = <TValue> (value: TValue | null | undefined): value is TValue => {
    return value == null && value == undefined;
}